import styled from "styled-components";

const BackgroundImage = styled.img`

width:100%;
height:300px;
margin-bottom: 20px;

src: ${props => props.src};



`

export default BackgroundImage